import { Component, OnInit } from '@angular/core';
import { PageTitleService } from 'app/core/page-title/page-title.service';

@Component({
  selector: 'app-chi-siamo',
  templateUrl: './chi-siamo.component.html',
  styleUrls: ['./chi-siamo.component.css']
})
export class ChiSiamoComponent implements OnInit {

  constructor(private pageTitleService: PageTitleService) {
    this.pageTitleService.setSubTitle('');
    this.pageTitleService.setTitle('');
   }

  ngOnInit(): void {
  }

}
